import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Card from "components/card";
import SummaryHeader from "components/header/SummaryHeader";
import { FileText } from "lucide-react";
import SearchFilter from "components/search/SearchFilter";
import OvertimeRequestTab from "./components/OvertimeRequestTab";
import {
  getOvertimeStat, getOvertimeList
} from "../../../../redux/overtime/overtimeState";
import { handleTableChange } from "../../../../utils/index";

const OvertimeRequests = ({
  recordStat,
  doSearch,
  pagination,
  filters = {},
  getStats, 
}) => {
  
  useEffect(() => {
    getStats();
  }, [getStats]);

  useEffect(() => {
    doSearch({
      ...(filters || {}),
      page: 1,
      paginate: pagination?.per_page || 10,
    });
  }, [doSearch]);


  return (
    <div className="flex flex-col">
      <div className="space-y-6 max-w-[1800px]">
        <SummaryHeader
          title="Overtime Request Management"
          icon={FileText}
          description="Review and manage employee overtime requests"
          color="blue"
          rightNav={
            <div className="flex items-center gap-6 flex-shrink-0">
              <div className="text-right">
                <p className="text-emerald-100/80 text-[12px] mb-1">
                  Pending Requests
                </p>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-orange-400 animate-pulse" />
                  <p className="text-[28px] font-bold text-white">{recordStat?.pending}</p>
                </div>
              </div>
            </div>
          }
        />

        <Card className="rounded-xl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
            <SearchFilter
              placeholder="Search by name, ID, or position..."
              searchHandler={doSearch} 
              filters={filters}
              pagination={pagination}
            />
          </div>
        </Card>

        <OvertimeRequestTab />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  recordStat: state.overtime.overtimeStat.data,
  filters: state.overtime.overtimeList.filters,
});

const mapDispatchToProps = (dispatch) => ({
  getStats: (data) => dispatch(getOvertimeStat(data)),
  doSearch: (filters) => dispatch(getOvertimeList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OvertimeRequests);
